// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3hxer","modal":"Modal_modal__2txv_","slide-down":"Modal_slide-down__3UHet"};